<template>
  <div>
    <i v-if="icon" class="icon-edit-02 padding-right-parent" @click.prevent="toggleModal">
      <span class="tooltiptext">{{ $t("button.tooltip.update") }}</span>
    </i>
    <a v-else @click.prevent="toggleModal" class="btn button btn-primary"> <i class="icon-edit-03"></i> {{ $t("common.edit") }} </a>
    <div v-if="show" class="modal-vue">
      <div class="overlay" @click="toggleModal"></div>
      <div class="modal-edition">
        <div class="titre-parent">
          <h3 class="title-modal">{{ $t("title.modifParent") }} {{ computedTypeParent }}</h3>
          <button class="close" @click="toggleModal()">
            <i class="icon-Add" />
          </button>
        </div>
        <form @submit.prevent="updateParent" novalidate autocomplete="off">
          <div class="spec-inputs">
            <div class="row">
              <div class="col-md-6">
                <div class="simple-input">
                  <label class="label">{{ $t("parent.form.email") }}</label>
                  <div class="inputcontainer">
                    <input v-model="user.email" @input="emailExists = false" type="email" class="form-control" :class="{'is-invalid': v$.user.email.$error || emailExists}" />
                    <span v-if="v$.user.email.$error || emailExists" class="invalid-feedback">
                      {{ v$.user.email.$error ? v$.user.email.$errors[0].$message : $t("error.uniqueEmail") }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="simple-input">
                  <label class="label"> {{ $t("parent.form.firstName") }}<sup>*</sup></label>
                  <div>
                    <input v-model="user.first_name" type="text" class="form-control" :class="{'is-invalid': v$.user.first_name.$error}" />
                    <span v-if="v$.user.first_name.$error" class="invalid-feedback">
                      {{ v$.user.first_name.$errors[0].$message }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="simple-input">
                  <label class="label">{{ $t("parent.form.lastName") }} <sup>*</sup></label>
                  <div>
                    <input v-model="user.last_name" type="text" class="form-control" :class="{'is-invalid': v$.user.last_name.$error}" />
                    <span v-if="v$.user.last_name.$error" class="invalid-feedback">
                      {{ v$.user.last_name.$errors[0].$message }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="simple-input">
                  <label class="label">{{ $t("parent.form.phone") }}<sup>*</sup></label>
                  <div>
                    <input
                      v-model="user.phone"
                      oninput="this.value = this.value.replace(/[^0-9+]/g, '').replace(/(\..*)\+/g, '$1');"
                      type="tel"
                      maxlength="8"
                      minlength="8"
                      class="form-control tel"
                      @input="phoneExists = false"
                      :class="{'is-invalid': v$.user.phone.$error || phoneExists}"
                    />
                    <span v-if="v$.user.phone.$error || phoneExists" class="invalid-feedback">
                      {{ v$.user.phone.$error ? v$.user.phone.$errors[0].$message : $t("error.existPhone") }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="simple-input">
                  <label class="label">{{ $t("parent.form.fonction") }}</label>
                  <div>
                    <input v-model="user.function" type="text" class="form-control" />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="simple-input simple-select">
                  <label class="label">{{ $t("parent.form.lieu") }}</label>
                  <input v-model="user.lieu_travail" type="text" class="form-control" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="simple-input">
                  <label class="label">{{ $t("parent.form.address") }}</label>
                  <div>
                    <input v-model="user.addresse" type="text" class="form-control" />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="simple-input simple-select">
                  <label class="label">{{ $t("parent.form.ville") }}</label>
                  <input v-model="user.ville" type="text" class="form-control" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="simple-input">
                  <label class="label">{{ $t("parent.form.code") }}</label>
                  <div>
                    <input
                      v-model="user.code_postale"
                      oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\+/g, '$1');"
                      type="tel"
                      maxlength="4"
                      minlength="4"
                      class="form-control"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="simple-input simple-select">
                  <label class="label">{{ $t("parent.form.pays") }}</label>
                  <input v-model="user.pays" type="text" class="form-control" />
                </div>
              </div>
              <div v-if="checkIfElementPayIsEleves" class="col-md-12 simple-input paiement-content align-items-end">
                <label class="label label-name">{{ $t("common.paiement") }}</label>
                <div class="switch-button">
                  <label class="switch">
                    <input v-model="user.has_payment" type="checkbox" />
                    <span class="slider round" />
                  </label>
                </div>
              </div>
              <div class="col-md-12">
                <button :disabled="isSubmitted" class="btn button btn-primary custom-btn">
                  {{ $t("button.savePeriod") }}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import useValidate from "@vuelidate/core";
import ParentService from "../../services/parent.service";
import {required, maxLength, helpers, email, minLength} from "@vuelidate/validators";
export default {
  name: "edit-parent",
  props: {
    parent: {
      type: Object,
      required: true,
    },
    icon: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      show: false,
      v$: useValidate(),
      phoneExists: false,
      emailExists: false,
      user: {},
      isSubmitted: false,
    };
  },
  computed: {
    computedTypeParent() {
      if (this.user.is_tuteur === 0) {
        return this.user.gender === 0 ? this.$t("parents.father") : this.$t("parents.mother");
      }
      return this.$t("parents.tutor");
    },
    checkIfElementPayIsEleves() {
      const userModuleArray = Object.values(this.$store.state.auth.user.modules);
      return userModuleArray.some((element) => element.name === this.$t("modules.payment"));
    },
  },
  validations() {
    return {
      user: {
        first_name: {
          required: helpers.withMessage(this.$t("validation.required"), required),
          maxLength: maxLength(100),
        },
        last_name: {
          required: helpers.withMessage(this.$t("validation.required"), required),
          maxLength: maxLength(100),
        },
        email: {
          email: helpers.withMessage(this.$t("validation.email"), email),
          maxLength: maxLength(100),
        },
        phone: {
          required: helpers.withMessage(this.$t("validation.required"), required),
          maxLength: helpers.withMessage(this.$t("validation.phoneMaxLength"), minLength(8)),
        },
      },
    };
  },
  methods: {
    toggleModal() {
      this.user = {...this.parent};
      this.show = !this.show;
    },
    updateParent() {
      this.v$.$validate();
      if (!this.v$.$invalid) {
        this.isSubmitted = true;
        ParentService.update(this.user.id, this.user)
          .then(() => {
            this.toggleModal();
            this.$emit("handleData");
          })
          .catch((error) => {
            this.phoneExists = error.response.data.errors?.phone ?? false;
            this.emailExists = error.response.data.errors?.email ?? false;
          })
          .finally(() => {
            this.isSubmitted = false;
          });
      }
    },
  },
};
</script>

<style></style>
